import api from "../../api/apiInterceptor";

export const fetchAllTables = (installationId) => {
    return api.get(`/api/installations/${installationId}/tableviews`)
}

export const fetchDeviceTypes = () => {
    return api.get("/api/devicetypes")
}

export const fetchAllTableLocations = (installationId) =>{
    return api.get(`/api/installations/${installationId}/locations/all`)
}
export const fetchAllDevicesOnInstallation = (installationId) =>{
    return api.get(`/api/installations/${installationId}/devices`)
}

export const addTableRow = (installationId, tableId, selectedOption) =>{
    return api.post(`/api/installations/${installationId}/tableviews/${tableId}/rows`, {
        locationId: selectedOption
    })
}

export const crateTableApi = (installationId, data) => {
    return api.post(`/api/installations/${installationId}/tableviews`, data)
}

export const editTableApi = (installationId, tableId, data) =>{
    return api.put(`/api/installations/${installationId}/tableviews/${tableId}`,data)
}
export const deleteTableApi = (installationId, tableId) =>{
    return api.delete(`api/installations/${installationId}/tableviews/${tableId}`)
}

export const getDynamicTable = (installationId, tableId, pagination) => {
    return api.get(`/api/installations/${installationId}/tableviews/${tableId}?page=${pagination.current - 1}&size=${pagination.pageSize}`)
}
export const getTableLocations = (installationId, pagination) => {
    return api.get(`/api/installations/${installationId}/locations?page=${pagination.current - 1}&size=${pagination.pageSize}`)
}